import { render, staticRenderFns } from "./InboundEdiResults.vue?vue&type=template&id=cc8fe1e4&scoped=true&"
import script from "./InboundEdiResults.vue?vue&type=script&lang=js&"
export * from "./InboundEdiResults.vue?vue&type=script&lang=js&"
import style0 from "./InboundEdiResults.vue?vue&type=style&index=0&id=cc8fe1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8fe1e4",
  null
  
)

/* custom blocks */
import block0 from "./InboundEdiResults.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports